var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66634 10.9997C2.72082 10.9997 0.333008 8.61186 0.333008 5.66634C0.333008 2.72082 2.72082 0.333008 5.66634 0.333008C8.61186 0.333008 10.9997 2.72082 10.9997 5.66634C10.9997 6.89882 10.5816 8.03365 9.87958 8.93677L13.4711 12.5283L12.5283 13.4711L8.93677 9.87958C8.03365 10.5816 6.89882 10.9997 5.66634 10.9997ZM9.66634 5.66634C9.66634 7.87548 7.87548 9.66634 5.66634 9.66634C3.4572 9.66634 1.66634 7.87548 1.66634 5.66634C1.66634 3.4572 3.4572 1.66634 5.66634 1.66634C7.87548 1.66634 9.66634 3.4572 9.66634 5.66634Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.5d937e61cf20c0f8509ca7421a414abf.svg";
export { ForwardRef as ReactComponent };